import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dreamy-cream py-20 px-6 md:px-20 border-t border-dreamy-gold/10">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-12">
        {/* Brand & Sign-off */}
        <div className="text-center md:text-left space-y-4">
          <h2 className="font-serif text-3xl text-dreamy-earth italic">
            StillsBy<span className="not-italic font-light">Hasanka</span>
          </h2>
          <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-dreamy-earth/50">
            Capturing the light in Sri Lanka & Beyond
          </p>
        </div>

        {/* Quick Navigation */}
        <div className="flex flex-wrap justify-center gap-8 font-sans text-[11px] tracking-widest uppercase text-dreamy-earth/70">
          <Link to="/" className="hover:text-dreamy-gold transition-colors">
            Home
          </Link>
          <Link
            to="/gallery"
            className="hover:text-dreamy-gold transition-colors"
          >
            Gallery
          </Link>
          <Link
            to="/about"
            className="hover:text-dreamy-gold transition-colors"
          >
            About
          </Link>
          <Link
            to="/contact"
            className="hover:text-dreamy-gold transition-colors"
          >
            Contact
          </Link>
        </div>

        {/* Socials & Connect */}
        <div className="flex flex-col items-center md:items-end gap-4">
          <div className="flex gap-6">
            <a
              href="https://www.instagram.com/stillsbyhasanka"
              target="_blank"
              rel="noopener noreferrer"
              className="text-dreamy-earth/60 hover:text-dreamy-gold transition-colors"
            >
              <span className="font-sans text-[11px] tracking-widest uppercase">
                Instagram
              </span>
            </a>
            <a
              href="https://www.facebook.com/stillsbyhasanka"
              target="_blank"
              rel="noopener noreferrer"
              className="text-dreamy-earth/60 hover:text-dreamy-gold transition-colors"
            >
              <span className="font-sans text-[11px] tracking-widest uppercase">
                Facebook
              </span>
            </a>
          </div>
          <p className="font-sans text-[10px] text-dreamy-earth/40 italic">
            dusktheory.lk@gmail.com
          </p>
        </div>
      </div>

      {/* Bottom Copyright Bar */}
      <div className="mt-20 pt-8 border-t border-dreamy-earth/5 text-center">
        <p className="font-sans text-[10px] tracking-[0.2em] uppercase text-dreamy-earth/40">
          &copy; {currentYear}{" "}
          <span className="text-dreamy-earth/70">StillsByHasanka</span>. All
          Rights Reserved.
          <span className="mx-2">|</span>
          Developed By{" "}
          <a
            href="https://syntaxware.site"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dreamy-earth/70 hover:underline"
          >
            Syntaxware Solutions
          </a>
          .
        </p>
      </div>
    </footer>
  );
};

export default Footer;
